import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import Banner, { BannerColor, BannerType } from '@divvy-web/skylab.banner'

export interface NonAuthSignerDisclaimerBannerProps {
  authEmail: string | null | undefined
}

const NonAuthSignerDisclaimerBanner = ({ authEmail }: NonAuthSignerDisclaimerBannerProps) => {
  return (
    <Banner
      backgroundColor={BannerColor.Info}
      bannerType={BannerType.Informative}
      messageContent={
        <FormattedMessage
          defaultMessage='Only the authorized signer ({email}) can accept this offer.'
          id='sputnik.NonAuthSignerDisclaimerBanner__TdYnmo'
          values={{
            email: authEmail,
          }}
        />
      }
    />
  )
}

export default NonAuthSignerDisclaimerBanner
